import { usePageProps } from '@redbubble/next-provider';
import React from 'react';
import { ProductPageProps } from '../../types';
import { useSimilarDesignsContext } from '../../utils/SimilarDesignsContext';
import { SimilarDesignsSection } from '../SimilarDesignsSection/SimilarDesignsSection';

const SimilarDesignsContainer: React.FC = () => {
  const { inventoryCategorySet, iaEntityCopy } =
    usePageProps<ProductPageProps>();

  const { work } = inventoryCategorySet.defaultItem;
  const { similarDesignsData, similarDesignsLoading } =
    useSimilarDesignsContext();

  return (
    <SimilarDesignsSection
      iaEntityCopy={iaEntityCopy}
      firstTag={work.tags[0] || null}
      similarDesignsLoading={similarDesignsLoading}
      similarDesigns={similarDesignsData.similarDesigns}
    />
  );
};

export default SimilarDesignsContainer;
